import script from "./mobileheader.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileheader.vue?vue&type=script&setup=true&lang=js"

import "./mobileheader.vue?vue&type=style&index=0&id=318d14fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-318d14fa"]])

export default __exports__